import {
  BanknotesIcon,
  ViewfinderCircleIcon,
} from "@heroicons/react/24/outline";
import PerformanceChart from "./Home/components/PerformanceChart";
import ShowCount from "../components/Cards/ShowCount";
import { ButtonBase } from "@repo/ui/index.tsx";
import { handleSuccessToast } from "@/UI/Toasts";

export default function App() {
  function handleDragStart(event: React.DragEvent<HTMLDivElement>) {
    event.dataTransfer.setData("text/plain", event.currentTarget.id);
  }

  function dragoverHandler(event: React.DragEvent<HTMLDivElement>) {
    event.preventDefault();
    const element = event.target as HTMLDivElement;
    element.style.backgroundColor = "#7773";
    element.style.border = "none";
  }

  function dropHandler(event: React.DragEvent<HTMLDivElement>) {
    event.preventDefault();
    const draggableElementId = event.dataTransfer.getData("text/plain");
    const draggableElement = document.getElementById(draggableElementId);
    (event.target as HTMLDivElement).appendChild(draggableElement!);
  }

  return (
    <div className="h-screen w-full p-4">
      <h2 className="text-xl font-semibold mb-2">Drop element here!</h2>
      <section className="flex items-start gap-10">
        <div
          onDrop={dropHandler}
          onDragOver={dragoverHandler}
          className="h-56 min-w-96 rounded-lg border border-dashed"
        />
        <section className="flex flex-col gap-2 ">
          <div
            id="draggable"
            draggable="true"
            className="w-96 h-56 relative"
            onDragStart={handleDragStart}
          >
            <PerformanceChart />
          </div>
          <div
            id="draggable2"
            draggable="true"
            className="w-96 h-56 relative"
            onDragStart={handleDragStart}
          >
            <ViewfinderCircleIcon className="size-6 text-gray select-none absolute right-2 top-2" />

            <ShowCount
              icon={
                <BanknotesIcon className="size-8 text-error/90 rounded-full bg-error/10 p-2 " />
              }
              labelComponent={
                <p className="text-sm font-black text-darkGray">
                  Avg. daily premium
                </p>
              }
              valueComponent={
                <p className="text-lg font-semibold text-heading">$ 3,623</p>
              }
              className="bg-white text-subHeading border border-extraLightGray w-96 h-full"
            />
          </div>
        </section>

        <ButtonBase
          text="Test"
          className="bg-tertiary"
          onClick={() => {
            handleSuccessToast({
              message:
                "Test Success another test found anything lkdfkgdfkgjh ljdflgj dfguiuhasfb ud dfgji soidfjos",
            });
          }}
        />
      </section>
    </div>
  );
}
